mutation UpdateMatchCampaign($matchCampaignInput: MatchCampaignInput!) {
  updateMatchCampaign(input: { matchCampaignInput: $matchCampaignInput }) {
    matchCampaign {
      id
    }
  }
}
